import * as Sentry from '@sentry/browser'
import * as networkService from '../services/networkService'
import * as routeService from '../services/routeService'
import * as translationService from '../services/translationService'
import { getApiErrorMessage } from '../utils/apiError'
import * as flowAction from './FlowAction'

export const PHONE_EXIST_REQUEST = 'PHONE_EXIST_REQUEST'
export const PHONE_EXIST_SUCCESS = 'PHONE_EXIST_SUCCESS'
export const PHONE_EXIST_FAILURE = 'PHONE_EXIST_FAILURE'
export const PHONE_IS_VERIFIABLE = 'PHONE_IS_VERIFIABLE'

export const EMAIL_EXIST_REQUEST = 'EMAIL_EXIST_REQUEST'
export const EMAIL_EXIST_SUCCESS = 'EMAIL_EXIST_SUCCESS'
export const EMAIL_EXIST_FAILURE = 'EMAIL_EXIST_FAILURE'

export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR'
export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'

export const USER_VERIFY_REQUEST = 'USER_VERIFY_REQUEST'
export const USER_VERIFY_SUCCESS = 'USER_VERIFY_SUCCESS'
export const USER_VERIFY_ERROR = 'USER_VERIFY_ERROR'

export const CONFIRM_PHONE_NUMBER_REQUEST = 'CONFIRM_PHONE_NUMBER_REQUEST'
export const CONFIRM_PHONE_NUMBER_SUCCESS = 'CONFIRM_PHONE_NUMBER_SUCCESS'
export const CONFIRM_PHONE_NUMBER_ERROR = 'CONFIRM_PHONE_NUMBER_ERROR'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export const REFRESH_ACCESS_TOKEN_SUCCESS = 'REFRESH_ACCESS_TOKEN_SUCCESS'

export const TAC_REQUEST = 'TAC_REQUEST'
export const TAC_SUCCESS = 'TAC_SUCCESS'
export const TAC_ERROR = 'TAC_ERROR'

export const TAC_UPDATE_REQUEST = 'TAC_UPDATE_REQUEST'
export const TAC_UPDATE_SUCCESS = 'TAC_UPDATE_SUCCESS'
export const TAC_UPDATE_ERROR = 'TAC_UPDATE_ERROR'

export const GET_REQUIREMENTS_REQUEST = 'GET_REQUIREMENTS_REQUEST'
export const GET_REQUIREMENTS_SUCCESS = 'GET_REQUIREMENTS_SUCCESS'
export const GET_REQUIREMENTS_ERROR = 'GET_REQUIREMENTS_ERROR'

export const LOGOUT_USER = 'LOGOUT_USER'
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR'

export const USER_PASSWORD_RESET_REQUEST = 'USER_PASSWORD_RESET_REQUEST'

export const SET_NEW_USER = 'SET_NEW_USER'
export const SET_IS_NEW_USER = 'SET_IS_NEW_USER'

export function setNewUser(newUser) {
  return {
    type: SET_NEW_USER,
    newUser,
  }
}

export function updateUser(user) {
  return {
    type: UPDATE_USER,
    user,
  }
}

export function logoutUser() {
  return {
    type: LOGOUT_USER,
  }
}

export function userInfoError(error) {
  return {
    type: UPDATE_USER_ERROR,
    error,
  }
}
export function userInfoSuccess(userInfo) {
  return {
    type: UPDATE_USER_SUCCESS,
    userInfo,
  }
}
export function userInfoRequest() {
  return {
    type: UPDATE_USER_REQUEST,
  }
}

function requestResetPasswordReset(phoneOrEmail) {
  return {
    type: USER_PASSWORD_RESET_REQUEST,
    phoneOrEmail,
  }
}

function requestPhoneExist(mobileNumber) {
  return {
    type: PHONE_EXIST_REQUEST,
    mobileNumber,
  }
}

function requestPhoneExistError(mobileNumber, error) {
  return {
    type: PHONE_EXIST_FAILURE,
    userExist: undefined,
    mobileNumber,
    error,
  }
}

function receivePhoneExist(mobileNumber, exists, isVerifiable) {
  return {
    type: PHONE_EXIST_SUCCESS,
    userExist: exists,
    mobileNumber,
    isVerifiable,
  }
}

function setPhoneIsVerifiable(isVerifiable) {
  return {
    type: PHONE_IS_VERIFIABLE,
    isVerifiable,
  }
}

function requestEmailExist(email) {
  return {
    type: EMAIL_EXIST_REQUEST,
    email,
  }
}

function requestEmailExistError(email, error) {
  return {
    type: EMAIL_EXIST_FAILURE,
    userExist: undefined,
    email,
    error,
  }
}

function receiveEmailExist(email, exists) {
  return {
    type: EMAIL_EXIST_SUCCESS,
    userExist: exists,
    email,
  }
}

function requestVerifyAccount() {
  return {
    type: USER_VERIFY_REQUEST,
    user: undefined,
  }
}

function receivedVerifyAccount(userObj) {
  return {
    type: USER_VERIFY_SUCCESS,
    user: userObj,
  }
}

function errorVerifyAccount(error) {
  return {
    type: USER_VERIFY_ERROR,
    error: error,
  }
}

function confirmPhoneNumberRequest() {
  return {
    type: CONFIRM_PHONE_NUMBER_REQUEST,
  }
}
function confirmPhoneNumberSuccess(user) {
  return {
    type: CONFIRM_PHONE_NUMBER_SUCCESS,
    user: {
      ...user,
      unverifiedPhone: undefined,
    },
  }
}
function confirmPhoneNumberError(error) {
  return {
    type: CONFIRM_PHONE_NUMBER_ERROR,
    error: error,
  }
}

function loginRequest() {
  return {
    type: LOGIN_REQUEST,
    isFetching: true,
  }
}
function loginSuccess(user) {
  return {
    type: LOGIN_SUCCESS,
    isFetching: false,
    user: user,
  }
}
function loginError(error) {
  return {
    type: LOGIN_ERROR,
    isFetching: false,
    error: error,
  }
}

export function refreshAccessTokenSuccess({ accessToken, refreshToken }) {
  return {
    type: REFRESH_ACCESS_TOKEN_SUCCESS,
    accessToken,
    refreshToken,
  }
}

export function clearAuthError() {
  return {
    type: CLEAR_AUTH_ERROR,
  }
}

function tacRequest() {
  return {
    type: TAC_REQUEST,
    isFetching: true,
  }
}
function tacSuccess(tac) {
  return {
    type: TAC_SUCCESS,
    isFetching: false,
    tac,
  }
}
function tacError(error) {
  return {
    type: TAC_ERROR,
    isFetching: false,
    error: error,
  }
}

function tacUpdateRequest() {
  return {
    type: TAC_UPDATE_REQUEST,
    isFetching: true,
  }
}
function tacUpdateSuccess(tacVersionId) {
  return {
    type: TAC_UPDATE_SUCCESS,
    isFetching: false,
    tacVersionId,
  }
}
function tacUpdateError(error) {
  return {
    type: TAC_UPDATE_ERROR,
    isFetching: false,
    error: error,
  }
}

function getRequirementsRequest() {
  return {
    type: GET_REQUIREMENTS_REQUEST,
    isFetchingRequirements: true,
  }
}
function getRequirementsSuccess(requirements) {
  return {
    type: GET_REQUIREMENTS_SUCCESS,
    isFetchingRequirements: false,
    requirements,
  }
}
function getRequirementsError(error) {
  return {
    type: GET_REQUIREMENTS_ERROR,
    isFetchingRequirements: false,
    error: error,
  }
}

export function getTac() {
  return dispatch => {
    dispatch(tacRequest())
    return networkService
      .requestCurrentTac()
      .then(response => {
        return dispatch(tacSuccess(response.data))
      })
      .catch(err => {
        return dispatch(tacError(err.data))
      })
  }
}

export function updateTac(tacId, tacVersionId) {
  return dispatch => {
    dispatch(tacUpdateRequest())
    return networkService
      .updateTac(tacId)
      .then(() => {
        return dispatch(tacUpdateSuccess(tacVersionId))
      })
      .catch(err => {
        return dispatch(tacUpdateError(err.data))
      })
  }
}

export function getRequirements() {
  return dispatch => {
    dispatch(getRequirementsRequest())
    return networkService
      .requestCurrentRequirements()
      .then(response => {
        return dispatch(getRequirementsSuccess(response.data))
      })
      .catch(err => {
        return dispatch(getRequirementsError(err.data))
      })
  }
}

export function registerAccount(mobileNumber, email, password, captcha, tacId) {
  const payload = { mobileNumber, password, captcha, tacId }

  if (email) {
    payload.email = email
  }
  return dispatch => {
    dispatch(flowAction.clearFlowErrors())
    dispatch(requestVerifyAccount(mobileNumber))
    return networkService
      .createUser(payload)
      .then(response => {
        const user = response.data.data
        dispatch(clearAuthError())
        dispatch(receivedVerifyAccount({ ...user }))
        return user
      })
      .then(response => {
        if (response.unverifiedPhone && response.unverifiedPhoneIsVerifiable) {
          routeService.gotToPhoneNumberVerificationPage()
        } else {
          routeService.goToEmailVerificationPage()
        }
      })
      .catch(err => {
        const message = getApiErrorMessage(err)
        dispatch(errorVerifyAccount({ message }))
      })
  }
}

export function verifyAccount(mobileNumber, { password, firstname, lastname, email, ...userInfo }, tacId) {
  return dispatch => {
    dispatch(flowAction.clearFlowErrors())
    dispatch(requestVerifyAccount(mobileNumber))
    return networkService
      .createUser({ mobileNumber, password, firstname, lastname, email, tacId })
      .then(response => {
        dispatch(clearAuthError())
        dispatch(receivedVerifyAccount({ ...response.data.data, ...userInfo }))
      })
      .then(routeService.gotToPhoneNumberVerificationPage)
      .catch(err => {
        const message = getApiErrorMessage(err)
        dispatch(errorVerifyAccount({ message }))
      })
  }
}

export function confirmPhoneNumber(userID, pincode) {
  return dispatch => {
    dispatch(flowAction.clearFlowErrors())
    dispatch(confirmPhoneNumberRequest())
    return networkService
      .verifyPhoneNumber({ userID, pincode })
      .then(response => {
        if (`${response.status}` !== '200') {
          throw new Error('Incorrect pincode')
        }

        const { accessToken, refreshToken, ...rest } = response.data
        const information = { accessToken, refreshToken, isAuthenticated: true, ...rest }
        dispatch(confirmPhoneNumberSuccess(information))

        return networkService
          .getUserInformation({ token: accessToken })
          .then(userRes => dispatch(userInfoSuccess(userRes.data)))
          .catch(profileError => {
            if (process.env.REACT_APP_SENTRY) {
              Sentry.captureException(profileError)
            }
            console.error('Failed to preload user profile after phone confirmation', profileError)
          })
          .then(() => information)
      })
      .catch(err => {
        dispatch(confirmPhoneNumberError(err.data))
        return Promise.reject(err)
      })
  }
}

// TODO: proper error handling
export function fetchUserExist(mobileNumber) {
  return dispatch => {
    dispatch(flowAction.clearFlowErrors())
    dispatch(requestPhoneExist(mobileNumber))
    // TODO: Catch localization of user here ! and put it in cache!
    networkService
      .doesPhoneNumberExist({ mobileNumber })
      .then(response => {
        const userExist = response.data && response.data.exists
        const isVerifiable = response.data && response.data.isVerifiable

        if (userExist && isVerifiable && response.data.locale) {
          translationService.changeLocale(response.data.locale)
        }

        dispatch(setPhoneIsVerifiable(isVerifiable))

        if (isVerifiable) {
          dispatch(updateUser({ email: undefined }))
        }

        if (userExist) {
          dispatch(receivePhoneExist(mobileNumber, userExist, isVerifiable))
        }
        return { userExist, isVerifiable }
      })
      .then(({ userExist }) => {
        dispatch(clearAuthError())
        userExist ? routeService.goToPasswordLoginPage() : routeService.goToRegisterEmailPage()
      })
      .catch(err => {
        dispatch(requestPhoneExistError(mobileNumber, err.data))
        return Promise.reject(err)
      })
  }
}

export function fetchEmailExist(email) {
  return dispatch => {
    dispatch(flowAction.clearFlowErrors())
    dispatch(requestEmailExist(email))
    networkService
      .doesEmailExist(email)
      .then(response => {
        const userExist = response.data && response.data.exists

        if (userExist && response.data.locale) {
          translationService.changeLocale(response.data.locale)
        }

        dispatch(receiveEmailExist(email, userExist))
        return { userExist }
      })
      .then(({ userExist }) => {
        dispatch(clearAuthError())
        if (userExist) {
          routeService.goToPasswordLoginPage()
        } else {
          routeService.goToRegisterPasswordPage()
        }
      })
      .catch(err => {
        dispatch(requestEmailExistError(email, err.data))
        return Promise.reject(err)
      })
  }
}

// USER DOES A NORMAL LOGIN
export function doLogin(mobileNumber, password, email) {
  return dispatch => {
    dispatch(flowAction.clearFlowErrors())
    dispatch(loginRequest())
    // do login request
    return networkService
      .doLogin({ mobileNumber, password, email })
      .then(response => {
        const { accessToken } = response

        //get the users information
        const userId = response.userId
        return networkService.getUserInformation({ id: userId, token: accessToken }).then(userResponse => {
          const userData = {
            token: response.id,
            ...response,
            ...userResponse.data,
          }
          dispatch(loginSuccess(userData))

          if (userData.locale) {
            translationService.changeLocale(userData.locale)
          }

          if (process.env.REACT_APP_SENTRY) {
            Sentry.setUser({
              username: `${userResponse.data.firstname} ${userResponse.data.lastname}`,
              email: userResponse.data.email,
              id: userResponse.data.id,
            })
          }

          return userData
        })
      })
      .catch(err => {
        dispatch(loginError(mobileNumber, err.data))
        return Promise.reject(err)
      })
  }
}

export const doTokenLogin = token => async dispatch => {
  dispatch(flowAction.clearFlowErrors())
  dispatch(loginRequest())
  try {
    const loginRes = await networkService.doTokenLogin(token)
    const userRes = await networkService.getUserInformation({
      id: loginRes.data.data.userId,
      token: loginRes.data.data.accessToken,
    })
    const userData = {
      ...loginRes.data.data,
      token: userRes.data.id,
      ...userRes.data,
    }
    dispatch(loginSuccess(userData))
    return userData
  } catch (err) {
    dispatch(loginError(err.data))
  }
}

export const resendVerificationMail = email => {
  return dispatch => {
    dispatch(flowAction.clearFlowErrors())
    networkService
      .resendVerificationMail(email)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
}

export const resendVerificationSms = mobileNumber => {
  return dispatch => {
    dispatch(flowAction.clearFlowErrors())
    networkService
      .resendVerificationSms(mobileNumber)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
}

export function confirmVerifyEmail(userId, token) {
  return dispatch => {
    dispatch(userInfoRequest())
    return networkService
      .getUserInformation({ id: userId, token: token })
      .then(userResponse => {
        const userData = { ...userResponse.data }
        dispatch(userInfoSuccess(userData))
        return userData
      })
      .catch(err => {
        let jsonData = err.response && err.response.data
        dispatch(userInfoError(jsonData))
        return Promise.reject(jsonData)
      })
  }
}

export function getUserInfo(userId, token) {
  return dispatch => {
    dispatch(userInfoRequest())
    return networkService
      .getUserInformation({ id: userId, token: token })
      .then(userResponse => {
        const userData = { ...userResponse.data }
        dispatch(userInfoSuccess(userData))

        return userData
      })
      .catch(err => {
        let jsonData = err.response && err.response.data
        dispatch(userInfoError(jsonData))
        return Promise.reject(jsonData)
      })
  }
}

export function updateUserInformation(userInformation) {
  return dispatch => {
    dispatch(flowAction.clearFlowErrors())
    dispatch(userInfoRequest())
    return networkService
      .updateUserInfo(userInformation)
      .then(response => {
        const user = response.data.data
        dispatch(userInfoSuccess(user))
        return { success: true, data: user }
      })
      .catch(err => {
        dispatch(userInfoError(err.data))
        return Promise.reject({ success: false, data: err.data, serverError: err })
      })
  }
}

export function resetPasswordRequest(phoneOrEmail, captcha, isPhone) {
  return dispatch => {
    dispatch(flowAction.clearFlowErrors())
    dispatch(requestResetPasswordReset(phoneOrEmail))
    // TODO: Catch localization of user here ! and put it in cache!
    networkService
      .requestResetPasswordReset(phoneOrEmail, captcha, isPhone)
      .then(() => {
        if (isPhone) {
          routeService.goToResetPasswordRequestedPage()
        } else {
          routeService.goToResetPasswordLinkRequestedPage()
        }
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/AuthAction.js